// @flow
import { connect } from 'react-redux';

import PageHubEntrepriseOffre from 'components/page/template/PageHubEntrepriseOffre';
import type { StateType } from 'types/Actions';
import type { StateProps } from 'components/page/template/PageHubEntrepriseOffre';

export default connect(
  (state: StateType): StateProps => ({
    userPref: state.userState.userPref
  })
)(PageHubEntrepriseOffre);
